import { type ReactNode } from "react";
import { clinic } from "@/mocks/clinic";

/**
 * LINE相談CTA（SBDC公式LINE）。
 *
 * ・サイト内すべての「LINE相談 / LINEで相談」導線はこのコンポーネントを経由させる。
 * ・URLは clinic.lineUrl に一元管理する（各ページへの直書きを禁止）。
 * ・外部リンクとして新しいタブで開く（React Router の内部遷移として処理しない）。
 * ・URLが未設定・不正な場合はリンクを付与せず、"/" などへの誤遷移を防ぐ。
 */
export function LineButton({
  children,
  className = "",
  onClick,
}: {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  const url = typeof clinic?.lineUrl === "string" ? clinic.lineUrl.trim() : "";
  const isExternal = /^https?:\/\//i.test(url);

  // URLが未確定のときはリンクを生成しない（空hrefによる現在ページ/トップへの遷移を防止）
  if (!isExternal) {
    return (
      <span className={className} aria-disabled="true">
        {children}
      </span>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={className}
    >
      {children}
    </a>
  );
}